import React, { FC } from 'react';
import { CameraIcon, DocumentIcon, ImageIcon, SpreadsheetIcon } from '../IconSelectorComponent/IconSelectorComponent';

interface FileTypeIconSelectorComponentProps {
    fileName: string;
}

const FileTypeIconSelectorComponent: FC<FileTypeIconSelectorComponentProps> = (props) => {
    const { fileName } = props;
    const extension = fileName.split('.').pop();
    switch (extension) {
        case 'xls':
        case 'xlsx':
        case 'csv':
            return <SpreadsheetIcon color="white.main" />;
        case 'doc':
        case 'docx':
        case 'pdf':
        case 'txt':
            return <DocumentIcon color="white.main" />;
        case 'mp4':
        case 'mov':
            return <CameraIcon color="white.main" />;
        case 'jpg':
        case 'png':
            return <ImageIcon color="white.main" />;
        default:
            return <DocumentIcon color="white.main" />;
    }
};

export default FileTypeIconSelectorComponent;
